import { useState, useCallback } from 'react';
import PointsService, { type Achievement } from '../services/pointsService';

/**
 * Hook personalizado para gerenciar notificações de conquistas
 */
export function useAchievements() {
  const [achievement, setAchievement] = useState<Achievement | null>(null);
  const [showAchievement, setShowAchievement] = useState(false);
  const pointsService = PointsService.getInstance();

  /**
   * Verifica e mostra conquista ao ganhar pontos
   */
  const checkAchievementOnPoints = useCallback(async (
    memberId: string,
    oldPoints: number,
    newPoints: number,
    eventType: string
  ) => {
    try {
      const newAchievement = await pointsService.detectAchievements(
        memberId,
        oldPoints,
        newPoints,
        eventType
      );

      if (newAchievement) {
        console.log('🎉 [useAchievements] Nova conquista:', newAchievement);
        setAchievement(newAchievement);
        setShowAchievement(true);
        return true;
      }
      return false;
    } catch (error) {
      console.error('❌ [useAchievements] Erro ao verificar conquista:', error);
      return false;
    }
  }, [pointsService]);

  /**
   * Verifica e mostra conquista de quiz
   */
  const checkQuizAchievement = useCallback(async (
    memberId: string,
    totalQuizzes: number
  ) => {
    try {
      const newAchievement = await pointsService.detectQuizAchievement(
        memberId,
        totalQuizzes
      );

      if (newAchievement) {
        console.log('📝 [useAchievements] Conquista de quiz:', newAchievement);
        setAchievement(newAchievement);
        setShowAchievement(true);
        return true;
      }
      return false;
    } catch (error) {
      console.error('❌ [useAchievements] Erro ao verificar quiz:', error);
      return false;
    }
  }, [pointsService]);

  /**
   * Fecha a notificação de conquista
   */
  const closeAchievement = useCallback(() => {
    setShowAchievement(false);
    setTimeout(() => setAchievement(null), 300);
  }, []);

  return {
    achievement,
    showAchievement,
    checkAchievementOnPoints,
    checkQuizAchievement,
    closeAchievement
  };
}
